import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id:              string;
  name:            string;
  email:           string;
  role:            string;
  additionalRoles: string[];
  tenantId:        string | null;
  hospitalName:    string | null;
}

interface AuthState {
  user:              AuthUser | null;
  accessToken:       string | null;
  refreshToken:      string | null;
  isAuth:            boolean;
  requiresMfa:       boolean;
  mfaTempKey:        string | null;
  requiresMfaSetup:  boolean;
  mfaSetupTempKey:   string | null;

  setAuth:            (user: AuthUser, accessToken: string, refreshToken: string) => void;
  setMfaPending:      (tempKey: string) => void;
  setMfaSetupPending: (tempKey: string) => void;
  updateTokens:       (accessToken: string, refreshToken: string) => void;
  logout:             () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user:             null,
      accessToken:      null,
      refreshToken:     null,
      isAuth:           false,
      requiresMfa:      false,
      mfaTempKey:       null,
      requiresMfaSetup: false,
      mfaSetupTempKey:  null,

      setAuth: (user, accessToken, refreshToken) =>
        set({ user, accessToken, refreshToken, isAuth: true,
              requiresMfa: false, mfaTempKey: null,
              requiresMfaSetup: false, mfaSetupTempKey: null }),

      setMfaPending: (tempKey) =>
        set({ requiresMfa: true, mfaTempKey: tempKey, isAuth: false }),

      setMfaSetupPending: (tempKey) =>
        set({ requiresMfaSetup: true, mfaSetupTempKey: tempKey, isAuth: false }),

      updateTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken }),

      logout: () =>
        set({ user: null, accessToken: null, refreshToken: null, isAuth: false,
              requiresMfa: false, mfaTempKey: null,
              requiresMfaSetup: false, mfaSetupTempKey: null }),
    }),
    {
      name: 'as-auth',
      partialize: (state) => ({
        user:         state.user,
        accessToken:  state.accessToken,
        refreshToken: state.refreshToken,
        isAuth:       state.isAuth,
      }),
    }
  )
);
